import {
  SET_TARGET_SETTINGS_USERS_LOADING,
  SET_TARGET_SETTINGS_USERS_FULFILLED,
} from "../mutations.type";

export const state = {
  users: {
    data: [],
    loading: false,
  },
};

const mutations = {
  [SET_TARGET_SETTINGS_USERS_FULFILLED](state, value) {
    state.users.data = value;
    state.users.loading = false;
  },
  [SET_TARGET_SETTINGS_USERS_LOADING](state) {
    state.users.loading = true;
    state.users.data = [];
  },
};

const getters = {
  targetSettingsUsers: (state) => state.users,
};

export default {
  mutations,
  state,
  getters,
};
